import { LogErrors } from './../../LogErrors'

import { DoubleAttempt } from './../Helpers/DoubleAttempt'


const GetAllResults = async (idCenter, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/ReportExportAll"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/ReportExportAll", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetAllResults - DL Results', error)
    }
}

/**
 * Usa el mismo endpoint (/api/V5/Reports/ReportAttemptsGrouped) que la versión del Líder,
 * con IdUserRol: 2 (Instructor). El propio instructor se deriva del token en el backend,
 * por lo que no se envía ningún IdInstructor.
 */
const GetFilteredResults = async (center, group, course, block, ztudent = null, page, pageSize, token, returnAll = false, attemptScoreFilter = 0) => {
    try {
        const dataToSend = {
            idCenter: center,
            IdUserRol: 2,
            groupId: group,
            courseId: course,
            blockId: block,
            page: page,
            pageSize: pageSize,
            AttemptScoreFilter: attemptScoreFilter
        }

        if (ztudent) {
            dataToSend.idZtudiante = ztudent
        }

        // Cuando se pide el total encontrado por los filtros (sin paginar), el backend
        // devuelve todas las filas coincidentes en una sola respuesta (hasMore: false).
        if (returnAll) {
            dataToSend.returnAll = true
        }

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V5/Reports/ReportAttemptsGrouped"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetFilteredResults - DL', error)
    }
}

const GetReportDetails = async (idCenter, centerName, student, course, groupId, groupName, attemptNumber, evaluationToken, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter,
            centerName: centerName,
            studentId: student,
            courseId: course,
            token: evaluationToken,
            groupId: groupId,
            groupName: groupName,
            attemptNumber: attemptNumber
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/ReportAttemptDetail"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/ReportAttemptDetail", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetReportDetails - DL Results', error)
    }
}

/**
 * Obtiene el detalle pregunta por pregunta de un intento finalizado de un estudiante,
 * la misma información que el propio alumno ve en su página de resultados.
 */
const GetQuestionDetail = async (idCenter, studentId, courseId, evaluationToken, token) => {
    try {
        const dataToSend = {
            IdCenter: idCenter,
            IdUserRol: 2, // Perfil de Instructor
            StudentId: studentId,
            CourseId: courseId,
            Token: evaluationToken
        }

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V5/Reports/ReportQuestionDetail"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetQuestionDetail - DL Results', error)
        return { success: false, message: `No ha sido posible obtener el detalle de la evaluación.` }
    }
}

export { GetAllResults, GetFilteredResults, GetReportDetails, GetQuestionDetail };